// import CHIPSAJ from "./_chips-aj.js";
import barba from "@barba/core";
// import barbaCss from '@barba/css';

const app = {
	init: function () {
		setTimeout(function () {
			fillShapes();
		}, 1000);
		this.cbEvt();
		this.currBG = null;

		$(".mobile-menu").on("click", function () {
			// $("body").ad
			if ($("body").hasClass("mobile-nav-on")) {
				$("body").removeClass("mobile-nav-on");
			} else {
				$("body").addClass("mobile-nav-on");
			}
		});

		return this;
	},
	cbEvt: function () {
		if ($(".site-subtitle").hasClass("site-subtitle")) {
			var subPoolCnt = $(".site-subtitle span").length;
			if (subPoolCnt > 0) {
				$(".site-subtitle span")
					.eq(Math.floor(Math.random() * subPoolCnt))
					.addClass("active");
			}
		}

		$(".archive-list .archive-close")
			.not(".cbInit")
			.each(function () {
				$(this).addClass("cbInit");
				$(this).on("click", function () {
					$(this).closest("li").toggleClass("full-preview");
				});
			});
		$(".archive-list .item-toggle, .contributor-list .item-toggle")
			.not(".cbInit")
			.each(function () {
				$(this).addClass("cbInit");
				$(this).on("click", function () {
					$(this).closest("li").toggleClass("full-preview");
				});
			});
		$(".pagination-link a")
			.not(".cbInit")
			.each(function () {
				$(this).addClass("cbInit");
				$(this).on("click", function (e) {
					e.preventDefault();
					let scopeThis = $(this);
					scopeThis.parent().addClass("pending-out");
					// ajax get contents of link and append it
					var link = $(this).attr("href");
					$.ajax({
						url: link,
						success: function (data) {
							// targetEl.html(data);
							// app.cbEvt();
							let addHTML = $(data).find(".archive-list").html();
							scopeThis.closest(".archive-list").append(addHTML);
							$(".pending-out").remove();
							app.cbEvt();
						},
					});
				});
			});
		$("[data-blurbg]")
			.not(".cbInit")
			.each(function () {
				$(this).addClass("cbInit");
				$(this).hover(
					function () {
						var backBG = $(this).data("blurbg");
						bgTimer = setTimeout(function () {
							setPageBG(backBG);
						}, 100);
					},
					function () {
						clearTimeout(bgTimer);
					}
				);
			});

		$("[data-autobg]")
			.not(".cbAutoBGInit")
			.each(function () {
				$(this).addClass("cbAutoBGInit");
				var autoBG = $(this).data("autobg");
				if (autoBG && !app.currBG) {
					setPageBG(autoBG);
				}
			});
		$(".readmore-toggle").on("click", function () {
			$(this).closest(".wyg").addClass("read-on");
		});

		$(".alpha-jump a").on("click", function (e) {
			e.preventDefault();
			var target = $(this).attr("href");
			console.log(target);
			var targetPos = $(target).offset().top;
			$("html, body").animate({ scrollTop: targetPos }, 500);
			return false;
		});

		$(".dir-down").removeClass("dir-down");
	},
	purgeBGs: function () {
		let loopIndex = 0;
		let loopTotal = $(".blur-wrap .blur-item").length;
		$(".blur-wrap .blur-item").each(function () {
			// console.log(loopIndex, loopTotal);
			if (loopTotal > 2 && loopIndex < 1) {
				$(this).remove();
			}
			loopIndex++;
		});
	},
	newsletterBG: function () {
		let availableBGs = [
			"#b5e5a6",
			"#e5cda6",
			"#e5a6a6",
			"#a6d5e5",
			"#e5a6d0",
		];
		let randomBG =
			availableBGs[Math.floor(Math.random() * availableBGs.length)];
		$("body").attr("style", "--funBG: " + randomBG);
		$(".moire-wrap").attr(
			"style",
			"background-position: " +
				this.randBGGenerator() +
				"% " +
				this.randBGGenerator() +
				"%," +
				this.randBGGenerator() +
				"% " +
				this.randBGGenerator() +
				"%"
		);
	},
	randBGGenerator: function () {
		return 100 - Math.floor(Math.random() * 200);
	},
	// ajObj: CHIPSAJ.init(),
};
app.init();

// barba.use(barbaCss);
let timer = null;
let b = barba.init({
	debug: true,
	sync: false,
	views: [
		{
			namespace: "home",
			beforeEnter() {
				$(".nav-wrap .active").removeClass("active");
				$("body").attr("data-pagetype", "home");
				$("body").removeClass("mobile-nav-on");
			},
			afterEnter() {
				let defaultImg = $("[data-autobg]").data("autobg");
				if (defaultImg) {
					console.log(
						"attempting to set default BG to " + defaultImg
					);
					setPageBG(defaultImg);
				}
				// console.log("welcome home page");
			},
		},
		{
			namespace: "about",
			beforeEnter() {
				$(".nav-wrap .active").removeClass("active");
				$(".aboutToggle").addClass("active");
				clearBG();
				$("body").attr("data-pagetype", "about");
				$("body").removeClass("mobile-nav-on");
			},
		},
		{
			namespace: "topics",
			beforeEnter() {
				$(".nav-wrap .active").removeClass("active");
				$(".topicsToggle").addClass("active");
				allowBG();
				$("body").attr("data-pagetype", "topics");
				$("body").removeClass("mobile-nav-on");
			},
		},
		{
			namespace: "contributors",
			beforeEnter() {
				$(".nav-wrap .active").removeClass("active");
				$(".contributorsToggle").addClass("active");
				clearBG();
				$("body").attr("data-pagetype", "contributors");
				$("body").removeClass("mobile-nav-on");
			},
		},
		{
			namespace: "newsletter",
			beforeEnter() {
				$(".nav-wrap .active").removeClass("active");
				$(".dispatchToggle").addClass("active");
				app.newsletterBG();
				allowBG();
				$("body").attr("data-pagetype", "newsletter");
			},
		},
		{
			namespace: "search",
			beforeEnter() {
				$(".nav-wrap .active").removeClass("active");
				$(".searchToggle").addClass("active");
				allowBG();
				$("body").attr("data-pagetype", "search");
			},
			afterEnter() {
				var vm = this;
				this.cache = {};
				this.ajaxRequest = null;
				vm.canceler = null;
				this.classTimer = null;
				vm.isLoading = false;

				$("#s").on("keypress", function (event) {
					if (event.which == "13") {
						event.preventDefault();
					}
				});
				$("#s").on("keyup", function (event) {
					if (
						event.which == "13" ||
						event.which == "16" ||
						event.which == "20" ||
						event.which == "17" ||
						event.which == "18" ||
						event.which == "37" ||
						event.which == "38" ||
						event.which == "39" ||
						event.which == "40"
					) {
					} else {
						vm.runSearch();
					}
				});

				vm.runSearch = function () {
					if (vm.canceler) vm.canceler.resolve();
					vm.isLoading = true;
					$("#resultsArea,.searchLoading").addClass("isTyping");
					clearTimeout(timer);
					var query = $("#s").val();
					if ($("#s").val().length > 2) {
						setTimeout(function () {
							// pages.randColor =
							// 	colorArray[
							// 		Math.floor(
							// 			Math.random() * colorArray.length
							// 		)
							// 	];
							// $("head").append(
							// 	"<style>*::-moz-selection {color: #FFFFFF;background-color: " +
							// 		pages.randColor +
							// 		"; }*::selection {color: #FFFFFF;background-color: " +
							// 		pages.randColor +
							// 		"; } .single-result .post-excerpt strong strong:BEFORE { background-color:" +
							// 		pages.randColor +
							// 		"; }</style>"
							// );
							// $('link[rel="shortcut icon"]').attr(
							// 	"href",
							// 	"/favicons/" +
							// 		pages.randColor.replace("#", "") +
							// 		".png"
							// );
						}, 500);
						if (query in vm.cache) {
							vm.isLoading = false;
							// $location.path("/s/" + query);
							// $location.replace();
							history.pushState({}, "", "/?s=" + query);
							let results = vm.cache[query];
							$("#resultsArea").html(results);
							clearTimeout(timer);
							timer = setTimeout(function () {
								$("#resultsArea,.searchLoading").removeClass(
									"isTyping"
								);
							}, 300);
						} else {
							vm.ajaxRequest = $.ajax({
								url: "/?s=" + query,
								method: "GET",
								canceler: vm.canceler,
								success: function (response) {
									vm.isLoading = false;
									// $location.path("/s/" + query);
									// $location.replace();
									// set url to /s/query
									history.pushState({}, "", "/?s=" + query);
									var finalResponse = response;
									vm.cache[query] = $(finalResponse)
										.find("#search-results")
										.html(); //Add results to cache
									let results = vm.cache[query];
									$("#resultsArea").html(results);
									clearTimeout(timer);
									timer = setTimeout(function () {
										$(
											"#resultsArea,.searchLoading"
										).removeClass("isTyping");
									}, 100);
								},
							});
							// $http
							// 	.get("/?s=" + query, {
							// 		timeout: vm.canceler.promise,
							// 	})
							// 	.then(function (response) {
							// 		vm.isLoading = false;
							// 		$location.path("/s/" + query);
							// 		$location.replace();
							// 		var finalResponse = response.data;
							// 		vm.cache[query] = finalResponse; //Add results to cache
							// 		results = vm.cache[query];
							// 		$("#resultsArea").html(results);
							// 		clearTimeout(timer);
							// 		timer = setTimeout(function () {
							// 			$("#resultsArea").removeClass(
							// 				"isTyping"
							// 			);
							// 		}, 100);
							// 	});
						}
					} else {
						vm.isLoading = false;
						$("#resultsArea").empty();
					}
				};
			},
		},
	],
	transitions: [
		{
			name: "single-post",
			to: {
				namespace: ["single", "home"],
			},
			leave(data) {
				return gsap.to(data.current.container, {
					opacity: 0,
					position: "absolute",
					top: 0,
					width: "100%",
					transform: "translateY(20px)",
					duration: 0.15,
				});
			},
			enter(data) {
				app.cbEvt();
				return gsap.fromTo(
					data.next.container,
					{
						opacity: 0,
						transform: "translateY(20px)",
					},
					{
						opacity: 1,
						transform: "translateY(0)",
						delay: 1,
					}
				);
			},
		},
		{
			name: "opacity-transition",
			leave(data) {
				return gsap.to(data.current.container, {
					opacity: 0,
					position: "absolute",
					top: 0,
					width: "100%",
					duration: 0.15,
				});
			},
			enter(data) {
				app.cbEvt();
				return gsap.from(data.next.container, {
					opacity: 0,
				});
			},
		},
	],
});
barba.hooks.before(() => {
	document.querySelector("html").classList.add("is-transitioning");
	barba.wrapper.classList.add("is-animating");
});

// do something after the transition finishes
barba.hooks.after(() => {
	document.querySelector("html").classList.remove("is-transitioning");
	barba.wrapper.classList.remove("is-animating");
	// ga('set', 'page', window.location.pathname);
	// ga('send', 'pageview');
});

// scroll to the top of the page
barba.hooks.enter(() => {
	window.scrollTo(0, 0);
});

function clearBG() {
	$(".blur-item.active").removeClass("active");
}
function allowBG() {
	$(".blur-item").last().addClass("active");
}

function fillShapes() {
	var numRemaining = $(
		".svg-wrap svg g polygon, .svg-wrap svg g rect, .svg-wrap svg g path"
	).not(".filled").length;
	if (numRemaining > 0) {
		var targetedEl = Math.floor(Math.random() * numRemaining);
		$(".svg-wrap svg g polygon, .svg-wrap svg g rect, .svg-wrap svg g path")
			.not(".filled")
			.eq(targetedEl)
			.addClass("filled");
		var numTimer = numRemaining * 1.2;
		if (numTimer < 10) {
			numTimer = 10;
		}
		setTimeout(function () {
			fillShapes();
		}, numTimer);
	}
}

var bgTimer = null;

var BLUR_RADIUS = 15;

var canvas = document.querySelector("[data-canvas]");
var canvasContext = canvas.getContext("2d");
var drawBlur = function () {
	fadePct = 0;
	animateFade();
};
var blurBGImg = new Image();
var fadePct = 0;
// blurBGImg.src = document.querySelector('[data-canvas-image]').src;

function animateFade() {
	if (fadePct > 100) {
		return;
	}
	requestAnimationFrame(animateFade);
	// canvasContext.clearRect(0,0,canvas.width,canvas.height);
	var w = canvas.width;
	var h = canvas.height;
	canvasContext.save();
	canvasContext.globalAlpha = fadePct / 100;
	// console.log(blurBGImg);
	// canvasContext.drawImage(blurBGImg, 0, 0, w, h);
	// StackBlur.canvasRGB('blurCanvas', 0, 0, w, h, BLUR_RADIUS);
	// if(canvasContext.length > 0){
	// StackBlur.canvasRGBA('blurCanvas', 0, 0, w, h, BLUR_RADIUS);
	// }
	// StackBlur.image(sourceImage, targetCanvas, radius, blurAlphaChannel);
	canvasContext.drawImage(blurBGImg, 0, 0, w, h);
	StackBlur.canvasRGBA("blurCanvas", 0, 0, w, h, BLUR_RADIUS);
	// StackBlur.image('https://reallifemag.com/wp-content/uploads/2021/06/CarolineYoo_TechnoOrientalism-150x150.jpg', 'blurCanvas', 15, false);

	canvasContext.restore();

	fadePct = fadePct + 5;
}
function setPageBG(passedBG) {
	// console.log(app.currBG, passedBG);
	if (passedBG && app.currBG !== passedBG) {
		// console.log(app.currBG);
		var newImg = null;
		newImg = new Image();
		newImg.onload = function () {
			// _img.src = this.src;
			$(".blur-item.active").removeClass("active");
			$(".blur-wrap").append(
				'<div class="blur-item" style="background-image:url(\'' +
					passedBG +
					"');\"></div>"
			);
			setTimeout(function () {
				$(".blur-item").last().addClass("active");
				app.currBG = passedBG;
				app.purgeBGs();
			}, 10);
		};
		newImg.src = passedBG;
		// $(".blur-item.active").removeClass("active");
		// $(".blur-wrap").append(
		// 	'<div class="blur-item" style="background-image:url(\'' +
		// 		app.currBG +
		// 		"');\"></div>"
		// );

		// setTimeout(function () {
		// 	$(".blur-item").last().addClass("active");
		// }, 10);
		// setTimeout(function () {
		// 	if ($(".blur-item").length > 3) {
		// 	}
		// }, 1000);
		// TURN OFF BG Images locally
		/*blurBGImg.src = passedBG.replace('reallifemag.test','reallifemag.com');
		blurBGImg.onload = function() {
			drawBlur();
		};*/
	} else {
		// console.log("Skipping " + app.currBG + " because it exists");
	}
}

let vm = {};

vm.lastScrollY = 0;
vm.scrollPos = 0;
vm.scrollDelta = 0;
vm.subtitleOff = 0;
vm.sublogoOn = 0;
setTimeout(function () {
	vm.lastScrollY = window.scrollY;
});

vm.scrollDir = "";
vm.scrollDirF = "";
vm.winW = $(window).width();
$(window).resize(function () {
	vm.winW = $(window).width();
});

function onScroll() {
	vm.lastScrollY = window.scrollY;
	if (typeof vm.lastScrollY === "undefined" || vm.lastScrollY === null) {
		vm.lastScrollY = $(window).scrollTop();
	}
	requestTick();
}

function requestTick() {
	if (!vm.ticking) {
		vm.ticking = true;
		requestAnimationFrame(triggerScroll);
	}
}
function triggerScroll() {
	var el = document.querySelectorAll(".sub-logo-desktop");
	var elShare = document.querySelectorAll(".share-wrap");
	var subOnClass = "subOn";

	var tempDir = "down";
	if (vm.lastScrollY < vm.scrollPos) {
		if (vm.lastScrollY > 0) {
			tempDir = "up";
		} else {
			tempDir = "";
		}
	}

	var tempTog = document.querySelectorAll(".mobile-menu");
	if (typeof tempTog[0] !== "undefined") {
		var tog = tempTog[0];

		if (tempDir !== vm.scrollDir) {
			vm.scrollDir = tempDir;
			vm.scrollDelta = vm.lastScrollY;
		}

		var deltaCheck = Math.abs(vm.scrollDelta - vm.lastScrollY);
		if (vm.lastScrollY >= 250) {
			if (tog.classList) {
				tog.classList.add("scroll-bg");
			} else {
				tog.className += " scroll-bg";
			}
		} else {
			if (tog.classList) {
				tog.classList.remove("scroll-bg");
			}
		}
		if (vm.scrollDir === "down" && vm.lastScrollY >= 80) {
			if (deltaCheck >= 80) {
				if (tog.classList) {
					tog.classList.add("dir-down");
				} else {
					tog.className += " dir-down";
				}
			}
		} else {
			if (deltaCheck >= 80) {
				if (tog.classList) {
					tog.classList.remove("dir-down");
				}
			}
		}
		if (vm.scrollDir === "up") {
			if (deltaCheck >= 80) {
				if (tog.classList) {
					tog.classList.add("dir-up");
				} else {
					tog.className += " dir-up";
				}
			}
		} else {
			if (deltaCheck >= 80) {
				if (tog.classList) {
					tog.classList.remove("dir-up");
				}
			}
		}
	}

	if (vm.lastScrollY >= 205 && vm.sublogoOn === 0) {
		if ($(".sub-logo-desktop").classList) {
			$(".sub-logo-desktop").classList.add("subOn");
			// elShare[0].classList.add("subOn");
		} else {
			$(".sub-logo-desktop").className += " subOn";
			// elShare[0].className += " subOn";
		}
		vm.sublogoOn = 1;
	} else if (vm.lastScrollY < 205 && vm.sublogoOn === 1) {
		if ($(".sub-logo-desktop").classList) {
			$(".sub-logo-desktop").classList.remove("subOn");
			// elShare[0].classList.remove("subOn");
		}
		vm.sublogoOn = 0;
	}

	if (vm.winW >= 767) {
		if (vm.lastScrollY >= 20 && vm.subtitleOff === 0) {
			$(".site-subtitle").addClass("scTrig");
			vm.subtitleOff = 1;
		} else if (vm.lastScrollY < 20 && vm.subtitleOff === 1) {
			$(".site-subtitle").removeClass("scTrig");
			vm.subtitleOff = 0;
		} else {
		}
	}

	vm.scrollPos = vm.lastScrollY;
	vm.ticking = false;
}
window.addEventListener("scroll", onScroll, false);
